<template>
  <card :title="title" id="details" v-if="canEdit || canDelete" v-cloak>
    <div class="row">
      <div class="form-group col-sm-12 col-lg-6 text-left">
        <label class="control-label">{{ $t('common.name') }}</label>
        <input
          type="text"
          v-model="data.name"
          :placeholder="$t('common.name')"
          :class="{ 'field-error': $v.data.name.$error }"
          class="form-control"
        />
      </div>
    </div>

    <agro-action-buttons
      :data="data"
      :can-edit="canEdit"
      :can-delete="canDelete"
      @onSave="save"
      @onSaveAndNew="saveAndNew"
      :save-and-new="true"
      @onDelete="confirmDelete"
      @onGotoList="gotoList"
    ></agro-action-buttons>
  </card>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import required from "vuelidate/src/validators/required";
import { canDelete, canEdit, permissions, permissionTypes } from "@/helpers/Permissions";
import * as actions from "@/helpers/generalActions";
import AgroActionButtons from "@/components/AgroActionButtons/index";
import Forbidden from "@/pages/errors/Forbidden";

export default {
  name: "SMProductTypeDetails",
  components: { Forbidden, AgroActionButtons },
  data() {
    return {
      data: {},
    };
  },
  computed: {
    ...mapGetters({
      domain: "auth/domain",
    }),
    name() {
      return this.$t("stock_management.product_types.title");
    },
    config() {
      return {
        permission: permissions.SM_PRODUCTS,
        permission_type: permissionTypes.access,
        get: this.get,
        create: this.create,
        update: this.update,
        delete: this.delete,
        list_url: "/stock-management/sm-product-types",
        confirm_delete: true,
      };
    },
    actions() {
      return actions;
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    title() {
      return (this.data.uuid ? this.$t("common.edit") : this.$t("common.new")) + " " + this.name;
    },
  },
  methods: {
    ...mapActions({
      get: "smProductTypes/getSmProductType",
      create: "smProductTypes/createSmProductType",
      update: "smProductTypes/updateSmProductType",
      delete: "smProductTypes/deleteSmProductType",
    }),
    loadData() {
      return this.actions.getData(this, () => {}, () => {});
    },
    gotoList() {
      return actions.gotoList(this);
    },
    confirmDelete() {
      return this.actions.confirmDelete(this);
    },
    save() {
      this.data.company_uuid = this.domain?.uuid;
      return this.actions.save(this, this.config.list_url);
    },
    saveAndNew() {
      this.data.company_uuid = this.domain?.uuid;
      return this.actions.saveAndNew(this, "/stock-management/sm-product-types/add");
    },
  },
  mounted() {
    this.loadData();
    this.actions.handleParams(this);
  },
  watch: {
    $route: {
      handler: function () {
        this.actions.handleParams(this);
      },
      deep: true,
    },
    permission: {
      handler: function (newVal) {
        this.permissionModule = newVal;
      },
      deep: true,
    },
  },
  validations() {
    return {
      data: {
        name: {
          required,
        },
      },
    };
  },
};
</script>
